import { RouterProvider } from 'atomic-router-react';
import type { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { router } from '../shared/routing';
import { ErrorBoundary, ToastProvider, TooltipProvider } from '../shared/ui';
import { AppCrashed } from './app-crashed';
import { ShareDialog } from '../features/share-project';
import { SyncDialogs } from '../features/sync-dialogs';
import { CommandPalette } from '../widgets/command-palette';
import { HelpCenter } from '../widgets/help-center';
import { ReportDialog } from '../widgets/report';
import { Toaster } from '../widgets/toaster';
import { RoutesView } from './routes-view';

export function App({ i18n }: { i18n: i18n }) {
  return (
    <I18nextProvider i18n={i18n}>
      <TooltipProvider>
        <ToastProvider swipeDirection="left">
          <RouterProvider router={router}>
            <ErrorBoundary fallback={() => <AppCrashed />}>
              <RoutesView />
            </ErrorBoundary>
            <SyncDialogs />
            <ShareDialog />
            <ReportDialog />
            <CommandPalette />
            <HelpCenter />
          </RouterProvider>
          <Toaster />
        </ToastProvider>
      </TooltipProvider>
    </I18nextProvider>
  );
}
